<template>
<v-app>
    <Navbar />
    <LeftDrawer />
    <v-main style="background: #FAFAFA">
        <v-row>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-row>
    </v-main>
</v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import LeftDrawer from "../components/LeftDrawer.vue";
import {
    mapGetters
} from 'vuex'
export default {
    name: "App",
    components: {
        Navbar,
        LeftDrawer,
    },
    methods: {
        checklogin() {
            let username = localStorage.getItem('SET_USERNAME');
            if (username === null) {
                this.$router.push("/login");
            }
            //alert(username);

        }
    },
    computed: {
        currentRouteName() {
            return this.$route.fullPath.split('/').slice(1).join(' / ')
        },
        ...mapGetters(["loginusername"])
    },
    mounted() {
        this.checklogin();
    },
};
</script>
